export default "__VITE_ASSET__Bp$8cABw__"